<template>
  <div class="inputField" :class="{ inputInvalid: checkValidity && !isValid }">
    <label class="textBold" :for="fieldId">
      {{ $t("bnpl:special_field.customer.date_of_birth.label") }}
      <span v-if="required" class="bold" style="color: var(--systemError)">*</span>
    </label>
    <InputCalendar :id="fieldId" :default-value="new Date(model)" @input="blur($event)"/>
  </div>
</template>

<script setup>
import { useProfileStore } from "~~/stores/profile";

const props = defineProps({
  fieldId: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    required: true,
  },
  checkValidity: {
    type: Boolean,
    required: true,
  },
});

const emits = defineEmits(['input']);

const model = ref("");

const profileStore = useProfileStore();

const isValid = computed(() => {
  if (!props.required) return true;
  if (typeof model.value !== 'undefined' && !isNaN(new Date(model.value + ''))) return true;
  return false;
});

onBeforeMount(() => {
  model.value = profileStore.dateOfBirth;
  emits('input', model.value);
});

const blur = (newDate) => {
  model.value = new Date(newDate);
  profileStore.customerUpdate({ dateOfBirth: new Date(newDate) });
  emits('input', model.value);
};
</script>

<style scoped lang="scss"></style>
